import AiBotBadwordsAPI from 'dashboard/api/aiBot/badwords';
import { throwErrorMessage } from '../../utils/api';

const types = {
  SET_UI_FLAG: 'SET_UI_FLAG',
  SET_RECORDS: 'SET_RECORDS',
  ADD_RECORD: 'ADD_RECORD',
  UPDATE_RECORD: 'UPDATE_RECORD',
  REMOVE_RECORD: 'REMOVE_RECORD',
};

export const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getMeta: $state => $state.meta,
};

export const actions = {
  get: async ({ commit }, { botId }) => {
    commit(types.SET_UI_FLAG, { isFetching: true });
    try {
      const response = await new AiBotBadwordsAPI(botId).get();
      commit(types.SET_RECORDS, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, { botId, ...params }) => {
    commit(types.SET_UI_FLAG, { isCreating: true });
    try {
      const response = await new AiBotBadwordsAPI(botId).create(params);
      commit(types.ADD_RECORD, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { botId, id, ...params }) => {
    try {
      const response = await new AiBotBadwordsAPI(botId).update(id, params);
      commit(types.UPDATE_RECORD, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    }
  },

  delete: async ({ commit }, { botId, id }) => {
    try {
      await new AiBotBadwordsAPI(botId).delete(id);
      commit(types.REMOVE_RECORD, id);
      return id;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    }
  },

  bulk: async ({ commit }, { botId, ...params }) => {
    commit(types.SET_UI_FLAG, { isBulkImporting: true });
    try {
      const response = await new AiBotBadwordsAPI(botId).bulk(params);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isBulkImporting: false });
    }
  },
};

export const mutations = {
  [types.SET_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_RECORDS]($state, records) {
    $state.records = records;
  },
  [types.ADD_RECORD]($state, record) {
    $state.records = [...$state.records, record];
  },
  [types.UPDATE_RECORD]($state, record) {
    $state.records = $state.records.map(item =>
      item.id === record.id ? record : item
    );
  },
  [types.REMOVE_RECORD]($state, id) {
    $state.records = $state.records.filter(item => item.id !== id);
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
